
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiStw as ObiStwElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-stw.js';
 
 
 

 
 export const ObiStw = createComponent({
   react: React,
   tagName: 'obi-stw',
   elementClass: ObiStwElement,
   events: {
     
   }
  });
 
 